export default "__VITE_ASSET__64381248__"